import { FETCH_SCHEDULED_POSTS } from '../../constants/actions';
import { lastScheduledPost } from '../../selectors/classroom';
import { fetchTagPostsSuccess } from '../tags/tagPost';
import fetchReactionsSuccess from '../../reactions/operations/fetchReactionsSuccess.operation';
import { fetchCommentsSuccess } from '../comment/fetch';
import { groupCommentByPostReducer } from './utils';
import getFeed from '../../api/posts/feed';

const fetchScheduledPostsStart = (dispatch) => {
  dispatch({
    type: FETCH_SCHEDULED_POSTS,
    status: 'started',
  });
};

export const fetchScheduledPostsSuccess = (dispatch, scheduledPosts) => {
  dispatch({
    type: FETCH_SCHEDULED_POSTS,
    status: 'success',
    scheduledPosts,
  });
};

const fetchScheduledPostsError = (dispatch, error) => {
  dispatch({
    type: FETCH_SCHEDULED_POSTS,
    status: 'error',
    error,
  });
};

export const fetchScheduledPosts = (spaceId) => async (dispatch, getState) => {
  fetchScheduledPostsStart(dispatch);

  const state = getState();
  const lastPost = lastScheduledPost(state);
  const after = lastPost ? new Date(lastPost.scheduledFor) : new Date();

  try {
    const { tagPosts, comments, reactions, posts } = await getFeed({
      spaceId,
      after,
      scheduled: true,
    });

    fetchScheduledPostsSuccess(dispatch, posts);
    fetchTagPostsSuccess(tagPosts, dispatch);

    // accumulate all comments per post
    const commentPosts = comments.reduce(groupCommentByPostReducer, {});
    Object.keys(commentPosts).forEach((postId) => {
      if (postId) {
        fetchCommentsSuccess(postId, commentPosts[postId], dispatch);
      }
    });

    dispatch(fetchReactionsSuccess(reactions));
  } catch (e) {
    fetchScheduledPostsError(dispatch, e);
  }
};
